// #region Imports

import * as $ from "jquery";

// #endregion Imports

// #region Exports

export function initialize(): void {
    objectFillFallback();
}

// #endregion Exports

// #region Private functions
const openClass = 'expanded';

function objectFillFallback(): void {
    //$('[data-toggle]').on('click', handleToggle);
    $('.exposure__img-wrapper').each(function () {
        var $container = $(this),
            imgUrl = $container.find('img').prop('src');
        if (imgUrl) {
            $container
                .css('backgroundImage', 'url(' + imgUrl + ')')
                .addClass('compat-object-fit');
        }
    });
}


// #endregion Private functions